var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-gray-100 text-xs h-40 flex justify-center items-center rounded-sm py-2 px-2 w-full"},[_vm._v(" Form as seen by referee. ")])])
}]

export { render, staticRenderFns }